/* La Galerie du Parfum — progressive enhancement. Shopify owns cart & checkout. */
(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  let activeDrawer = null;
  let returnFocus = null;
  let inertStates = [];

  const focusables = root => [...root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex="0"]')].filter(node => {
    if (!node.getClientRects().length || node.closest('[inert]') || getComputedStyle(node).visibility === 'hidden') return false;
    for (let closed = node.closest('details:not([open])'); closed; closed = closed.parentElement?.closest('details:not([open])')) {
      if (!closed.querySelector(':scope > summary')?.contains(node)) return false;
    }
    return true;
  });
  const closeMenu = () => {
    if (!activeDrawer) return;
    const drawer = activeDrawer;
    drawer.classList.remove('is-open');
    drawer.inert = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-menu-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    document.querySelectorAll('[data-menu-overlay]').forEach(o => { o.hidden = true; });
    document.body.classList.remove('menu-open');
    inertStates.forEach(([node, previous]) => { node.inert = previous; });
    inertStates = [];
    activeDrawer = null;
    if (returnFocus?.isConnected) returnFocus.focus();
  };
  const openMenu = trigger => {
    if (activeDrawer) closeMenu();
    const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!drawer) return;
    returnFocus = trigger;
    activeDrawer = drawer;
    drawer.inert = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.querySelectorAll('[data-menu-overlay]').forEach(o => { o.hidden = false; });
    document.body.classList.add('menu-open');
    const background = document.querySelectorAll('main,.site-header,.footer,.announcement,.skip-link');
    inertStates = [...background].map(node => [node, node.inert]);
    background.forEach(node => { node.inert = true; });
    drawer.querySelector('[data-menu-close]')?.focus({ preventScroll: true });
  };

  const showMedia = (gallery, id) => {
    if (!gallery || !id) return;
    const target = [...gallery.querySelectorAll('[data-product-media]')].find(n => n.dataset.productMedia === String(id));
    if (!target) return;
    gallery.querySelectorAll('[data-product-media]').forEach(n => {
      n.classList.toggle('is-active', n === target);
      if (n !== target) n.querySelectorAll('video').forEach(v => v.pause());
    });
    gallery.querySelectorAll('[data-media-target]').forEach(n => n.setAttribute('aria-pressed', String(n.dataset.mediaTarget === String(id))));
  };
  const updateVariant = (select, updateURL = true) => {
    const form = select.closest('[data-product-form]');
    if (!form) return;
    const option = select.selectedOptions[0];
    if (!option) return;
    const section = form.closest('[data-product-section]');
    const price = section?.querySelector('[data-product-price]');
    const button = form.querySelector('[data-add-button]');
    const labels = form.querySelector('[data-product-labels]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      button.disabled = option.disabled;
      button.textContent = (option.disabled ? labels?.dataset.unavailableLabel : labels?.dataset.addLabel) || button.textContent;
    }
    if (option.dataset.media) showMedia(section?.querySelector('[data-product-gallery]'), option.dataset.media);
    if (updateURL && select.value && !window.Shopify?.designMode) {
      const url = new URL(location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState({}, '', url);
    }
  };

  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-menu-open]');
    if (opener) { openMenu(opener); return; }
    if (event.target.closest('[data-menu-close],[data-menu-overlay]')) { closeMenu(); return; }
    const mediaButton = event.target.closest('[data-media-target]');
    if (mediaButton) showMedia(mediaButton.closest('[data-product-gallery]'), mediaButton.dataset.mediaTarget);
    if (activeDrawer && event.target.closest('a[href]') && activeDrawer.contains(event.target)) closeMenu();
    document.querySelectorAll('[data-header-language][open],[data-nav-dropdown][open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) updateVariant(event.target);
    if (event.target.matches('[data-auto-submit]')) event.target.form?.requestSubmit();
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('[data-header-language][open],[data-nav-dropdown][open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (activeDrawer) { closeMenu(); return; }
      document.querySelectorAll('[data-header-language][open],[data-nav-dropdown][open]').forEach(details => {
        if (details.contains(document.activeElement)) details.querySelector('summary')?.focus();
        details.open = false;
      });
    }
    if (event.key === 'Tab' && activeDrawer) {
      const controls = focusables(activeDrawer);
      const first = controls[0], last = controls[controls.length - 1];
      if (!activeDrawer.contains(document.activeElement)) { event.preventDefault(); (event.shiftKey ? last : first)?.focus(); return; }
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  const desktop = matchMedia('(min-width: 1100px)');
  desktop.addEventListener('change', event => { if (event.matches) closeMenu(); });
  const initialise = root => root.querySelectorAll('[data-variant-select]').forEach(select => updateVariant(select, false));
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', closeMenu);
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
})();
